var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-body"},[_c('ul',_vm._l((_vm.lines),function(i){return _c('li',{key:i,staticClass:"skeleton-list-item"},[_vm._m(0,true),_vm._m(1,true)])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bar bar-title"}),_c('div',{staticClass:"bar bar-description"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bar bar-button"})])
}]

export { render, staticRenderFns }